module.exports = __webpack_public_path__ + "img/menu-item-feed.221a578b.svg";